import axiosClient from './axiosClient';

const zoomApi = {
  create: (data) => {
    const url = '/zooms';
    return axiosClient.post(url, data);
  },
  edit: (data, zoomId) => {
    const url = `/zooms/${zoomId}`;
    return axiosClient.put(url, data);
  },
  getAll: (params) => {
    const url = '/zooms';
    return axiosClient.get(url, { params });
  },
  advanceFilter: (data, { params }) => {
    const url = '/zooms/advance-filter';
    return axiosClient.post(url, data, { params });
  },
  getById: (id) => {
    const url = `/zooms/${id}`;
    return axiosClient.get(url);
  },
  delete: (zoomId) => {
    const url = `/zooms/${zoomId}`;
    return axiosClient.delete(url);
  },
};

export default zoomApi;
